import { getJobQuality, QUALITY_STYLES, type QualityResult } from "@/lib/jobQuality";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface JobQualityBadgeProps {
  job: any;
  className?: string;
  showTooltip?: boolean;
}

export function JobQualityBadge({ job, className, showTooltip = true }: JobQualityBadgeProps) {
  const q = getJobQuality(job);
  const style = QUALITY_STYLES[q.tier];

  const badge = (
    <span className={cn("inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-medium", style.bg, style.text, className)}>
      <span className={cn("w-1.5 h-1.5 rounded-full", style.dot)} />
      {style.label} ({q.filled}/{q.total})
    </span>
  );

  if (!showTooltip || q.missing.length === 0) return badge;

  return (
    <Tooltip>
      <TooltipTrigger asChild>{badge}</TooltipTrigger>
      <TooltipContent side="bottom" className="max-w-[220px]">
        <p className="text-xs font-medium mb-1">Campos faltantes:</p>
        <ul className="text-xs text-muted-foreground space-y-0.5">
          {q.missing.map((m) => (
            <li key={m}>• {m}</li>
          ))}
        </ul>
      </TooltipContent>
    </Tooltip>
  );
}
